var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDealers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.40552 11.9409H11.691L11.6195 11.5158C11.2243 9.15947 9.09086 7.4502 6.54848 7.4502C4.00516 7.4502 1.87177 9.15947 1.47652 11.5158L1.40552 11.9409Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54812 1.40527C5.42296 1.40527 4.54205 2.28665 4.54205 3.41134C4.54205 4.53602 5.42296 5.41788 6.54812 5.41788C7.67327 5.41788 8.55418 4.53602 8.55418 3.41134C8.55418 2.28665 7.67327 1.40527 6.54812 1.40527",
    stroke: "black",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.61639 14.68H18.4055L18.3307 14.2341C17.9161 11.7628 15.6785 9.96924 13.0107 9.96924C10.3434 9.96924 8.10584 11.7628 7.69118 14.2341L7.61639 14.68Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02466 14.5808C6.99547 14.7548 7.04438 14.9329 7.15838 15.0676C7.27238 15.2023 7.43991 15.28 7.61639 15.28H18.4055C18.582 15.28 18.7495 15.2023 18.8635 15.0676C18.9775 14.9329 19.0264 14.7548 18.9972 14.5808L18.9224 14.1349L18.9224 14.1349C18.4548 11.3475 15.9433 9.36924 13.0107 9.36924C10.0785 9.36924 7.56713 11.3475 7.09945 14.1349L7.09945 14.1349L7.02466 14.5808Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.61639 14.68H18.4055L18.3307 14.2341C17.9161 11.7628 15.6785 9.96924 13.0107 9.96924C10.3434 9.96924 8.10584 11.7628 7.69118 14.2341L7.61639 14.68Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.011 3.67163C11.8309 3.67163 10.9064 4.59609 10.9064 5.77568C10.9064 6.95575 11.8309 7.88067 13.011 7.88067C14.191 7.88067 15.1155 6.95575 15.1155 5.77568C15.1155 4.59609 14.191 3.67163 13.011 3.67163",
    stroke: "black",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealers);
export default __webpack_public_path__ + "static/media/dealers.32e670bfc4f52341a3993524629db167.svg";
export { ForwardRef as ReactComponent };